import { IGatsbyImageData } from "gatsby-plugin-image"

import PartnerSpotlight from "components/sectionTemplates/PartnerSpotlight"

export default function BluePenguin({ image }: { image: IGatsbyImageData }) {
  return <PartnerSpotlight localeImage={image} variant="bluePenguin" />
}
